import { useContext } from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { BottomSheetContext } from '../../../provider/bottomSheetProvider'

import { useNavigate } from '../../../hooks/useNavigate'

import { BottomSheet } from '../../../components/bottomSheet'
import { RowBetween } from '../../../components/common'
import { Text } from '../../../components/text'

import RendingImage from '../../../assets/gui/rending-bottom-sheet.png'
import { ReactComponent as Close } from '../../../assets/ico/common/close/close_white.svg'

export function RendingBottomSheet() {
  const { hideBottomSheet } = useContext(BottomSheetContext)

  const navigate = useNavigate()

  const goProduct = () => {
    hideBottomSheet()
    navigate('/market/product/61')
  }

  const expired = () => {
    localStorage.setItem('SecondProductYes24EventBottomSheetExpired', dayjs().toISOString())
    hideBottomSheet()
  }

  return (
    <BottomSheet>
      <ButtonBox>
        <Text size={16} weight={500} color="text_white" onClick={expired}>
          오늘은 그만 보기
        </Text>
        <Close onClick={hideBottomSheet} />
      </ButtonBox>
      <img src={RendingImage} alt="2호 청약 이벤트 이미지" onClick={goProduct} />
    </BottomSheet>
  )
}

const ButtonBox = styled(RowBetween)`
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 24px 8px;
  transform: translateY(-100%);
  > * {
    cursor: pointer;
  }
`
